import React, { useState } from "react";
import { styled } from "@mui/system";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomSelect = styled(Select)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
  color: "#00A7CD",
  border: "none",
  borderRadius: 0,
  fontFamily: "Avenir Book, sans-serif",
  "&:focus": {
    backgroundColor: "transparent",
  },
  "& .MuiSelect-icon": {
    color: "#00A7CD",
  },
  ".MuiSelect-root": {
    paddingLeft: "8px", // Adjust padding as needed
    paddingRight: "8px", // Adjust padding as needed
  },
  ".MuiSelect-select": {
    paddingLeft: "0", // Remove extra left padding
  },
  ".MuiSvgIcon-root": {
    color: "#00A7CD",
    transform: "rotate(0deg)",
  },
  ".MuiSelect-open .MuiSvgIcon-root": {
    transform: "rotate(180deg)",
  },
}));

const TableRowsPerPageSection = ({ rowsPerPage, onRowsPerPageChange }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomSelect
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      value={rowsPerPage}
      onChange={onRowsPerPageChange}
      sx={{
        height: 40,
        marginLeft: 3,
        fontFamily: "Avenir Book, sans-serif",
        ".MuiOutlinedInput-notchedOutline": { border: 0 },
        "&:selected": {
          backgroundColor: "transparent",
          border: 0,
        },
      }}
      IconComponent={() => (
        <ExpandMoreIcon onClick={handleOpen} style={{ cursor: "pointer" }} />
      )}
    >
      {/* <MenuItem value={8} style={{ fontFamily: "Avenir Book, sans-serif" }}>
        8 Per Page
      </MenuItem> */}
      <MenuItem value={25} style={{ fontFamily: "Avenir Book, sans-serif" }}>
        25 Per Page
      </MenuItem>
      <MenuItem value={50} style={{ fontFamily: "Avenir Book, sans-serif" }}>
        50 Per Page
      </MenuItem>
      <MenuItem value={100} style={{ fontFamily: "Avenir Book, sans-serif" }}>
        100 Per Page
      </MenuItem>
      <MenuItem value={200} style={{ fontFamily: "Avenir Book, sans-serif" }}>
        200 Per Page
      </MenuItem>
    </CustomSelect>
  );
};

export default TableRowsPerPageSection;
